.container {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;

  overflow-x: hidden;
  overflow-y: hidden;
}

.app {
  position: relative;
  display: flex;
  flex-direction: row;
  height: 100%;

  &[data-has-banner='true'] {
    max-height: calc(100% - 3.2rem);
  }
}

.main {
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: black;
  min-width: 0;

  @media (min-width: $bp-medium) {
    max-width: calc(100% - var(--drawer-width-closed));
  }
}

.content {
  flex: 1;
  max-height: calc(100% - 4rem);

  @media (min-width: $bp-medium) {
    padding: 0.4rem 0.4rem 0.4rem 0;
  }
}

.content-container {
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  background: var(--content-bg-color);

  @media (min-width: $bp-medium) {
    border: 1px var(--content-border-color) solid;
    border-radius: 4px;
  }
}
